module.exports = __webpack_public_path__ + "static/basf-6f538119a242cd549cb51a4d13062add.svg";